module.exports = __webpack_public_path__ + "img/1.a4f2cb80.gif";